import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'upperFirstLetter',
})
export class UpperFirstLetterPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) return null;
		const values = value
			.split(' ')
			.map((word) => word[0]?.replace(/[^a-zA-Z0-9 ]/g, '').toUpperCase()); // replace non-alphanumeric characters with empty string
		return values.join('');
	}
}
